// extracted by mini-css-extract-plugin
module.exports = {"expenseDescription":"style_expenseDescription__2RVJw","hidden":"style_hidden__fkYsw"};